// Shared deferred identity runtime. Browsers may cache a failed module URL, so
// the fallback uses a cache-distinct Vite module rather than merely clearing a
// rejected Promise and importing the poisoned URL again.

type AuthRuntime = typeof import('./auth');

let runtime: AuthRuntime | null = null;
let pending: Promise<AuthRuntime> | null = null;
let attempt = 0;
const loaders: Array<() => Promise<AuthRuntime>> = [
  () => import('./auth'),
  // @ts-expect-error Vite query creates a cache-distinct production module.
  () => import('./auth?retry=1') as Promise<AuthRuntime>,
];

export function currentAuth(): AuthRuntime | null {
  return runtime;
}

export function loadAuth(): Promise<AuthRuntime> {
  if (runtime) return Promise.resolve(runtime);
  if (pending) return pending;
  const loader = loaders[Math.min(attempt++, loaders.length - 1)];
  pending = loader().then((loaded) => {
    runtime = loaded;
    return loaded;
  }, (error) => {
    pending = null;
    throw error;
  });
  return pending;
}
